import { ReactNode } from "react"
import { apiErrorMessage, Flex, CenteredLoader, Text } from "@shared/primitive-components"

export const noContentText = `There are no results to show`
export const apiFailedText = apiErrorMessage
interface Props {
  children: ReactNode
  apiFailed?: boolean
  loading?: boolean
  dataTestIds?: {
    loading?: string
    text?: string
  }
}

export const ListWrapperChildren = ({ apiFailed, loading, dataTestIds, children }: Props) => {
  if (apiFailed) return <Text data-testid={dataTestIds?.text}>{apiFailedText}</Text>
  if (loading)
    return (
      <Flex data-testid={dataTestIds?.loading} alignItems="center" justifyContent="center" width="100%">
        <CenteredLoader />
      </Flex>
    )
  return <>{children}</>
}

ListWrapperChildren.defaultProps = {
  apiFailed: false,
  loading: false,
  dataTestIds: undefined,
}
